import { useEffect, useState } from "react";

const LUNCH_LIMIT_MS = 30 * 60 * 1000;

/** Formats elapsed milliseconds as a zero-padded MM:SS counter. */
export function formatElapsed(milliseconds: number): string {
  const elapsed = Math.max(0, Math.floor(milliseconds / 1000));
  const minutes = Math.floor(elapsed / 60);
  const seconds = elapsed % 60;
  return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
}

export interface LunchScreenProps {
  lunchStartedAt: string;
  onEndLunch: () => void;
}

/** Informational lunch takeover; duration is never enforced client-side. */
export default function LunchScreen({ lunchStartedAt, onEndLunch }: LunchScreenProps) {
  const [now, setNow] = useState(() => Date.now());
  const startedAt = new Date(lunchStartedAt).getTime();
  const elapsed = Math.max(0, now - startedAt);
  const overtime = elapsed > LUNCH_LIMIT_MS;

  useEffect(() => {
    const timer = window.setInterval(() => setNow(Date.now()), 1000);
    return () => window.clearInterval(timer);
  }, []);

  return (
    <main className={`lunch-screen${overtime ? " overtime" : ""}`}>
      <div className="lunch-screen-content">
        <h1>{overtime ? "Break over" : "On lunch"}</h1>
        <p className="lunch-countdown" aria-live="polite">{formatElapsed(elapsed)}</p>
        <p>
          {overtime
            ? "Break over — tap END LUNCH to punch back in"
            : "Lunch break timer"}
        </p>
        <button type="button" className="btn btn-primary" onClick={onEndLunch}>
          END LUNCH
        </button>
      </div>
    </main>
  );
}
